import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import baseStyles from './styles/base.module.css';

export default function Template({
    bottom,
    children,
    isFluid,
    isThin,
    backgroundCover,
    styles,
    theme,
    top,
    dataQa,
    removeMarginMobile,
}) {
    const templateClass = cx(
        baseStyles.template,
        {
            [baseStyles[`topSpacing${top}`]]: !!top,
            [baseStyles[`bottomSpacing${bottom}`]]: !!bottom,
            [baseStyles.thin]: isThin,
            [baseStyles.fluid]: isFluid,
            [baseStyles.noMarginMobile]: removeMarginMobile,
        },
        [styles.template],
    );

    const content = (
        <div className={templateClass} data-qa={dataQa}>
            {children}
        </div>
    );

    if (theme && theme !== Template.themes.transparent) {
        return (
            <div
                className={cx(baseStyles[`theme-${theme}`], {
                    [baseStyles.fullHeight]: backgroundCover,
                })}
            >
                {content}
            </div>
        );
    }

    return content;
}

Template.propTypes = {
    dataQa: PropTypes.string,
    /** @type {node} children - child items to be rendered within the content */
    children: PropTypes.node.isRequired,
    /** @type {boolean} template should take the full width of the window */
    isFluid: PropTypes.bool,
    /** @type {boolean} option to have content to max-width */
    isThin: PropTypes.bool,
    /** @type {boolean} option to have background full height */
    backgroundCover: PropTypes.bool,
    /** @type {string} any additional styles for the heading */
    styles: PropTypes.object,
    /** @type {object} color for the theme */
    theme: PropTypes.string,
    /** @type {string|null} padding to be applied to the top of the section */
    top: PropTypes.oneOf([null, 'XXS', 'XS', 'S', 'M', 'L', 'XL']),
    /** @type {string|null} padding to be applied to the bottom of the section */
    bottom: PropTypes.oneOf([null, 'XXS', 'XS', 'S', 'M', 'L', 'XL']),
};

Template.themes = {
    transparent: 'transparent',
    gallery: 'gallery',
    white: 'white',
    black: 'black',
    midnight: 'midnight',
};

Template.spacing = {
    XXS: 'XXS',
    XS: 'XS',
    S: 'S',
    M: 'M',
    L: 'L',
    XL: 'XL',
};

Template.defaultProps = {
    removeMarginMobile: false,
    dataQa: undefined,
    isThin: false,
    isFluid: false,
    backgroundCover: false,
    theme: null,
    top: null,
    bottom: null,
    styles: {},
};
